import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
// tslint:disable-next-line:max-line-length
import { ReservationWizardService, ReservationExtraordinaryWizardService, ReservationPreWizardService } from 'src/app/services/wizard/reservation/reservation.wizard.service';
import { ReservationPracticeComponent } from '../reservation-practice/reservation-practice.component';
import { ReservationPatientComponent } from '../reservation-patient/reservation-patient.component';
import { WizardStep, Wizard } from '../../../wizard/wizard.component';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material';
import { ReservationQuestionComponent } from '../reservation-question/reservation-question.component';
import { MenuService } from 'src/app/services/menu.service';
import { ActivatedRoute, Router } from '@angular/router';
// tslint:disable-next-line:max-line-length
import { ReservationExtraordinaryCalendarComponent } from '../reservation-extraordinary-calendar/reservation-extraordinary-calendar.component';

@Component({
  selector: 'app-reservation-pre-wizard-component',
  templateUrl: './reservation-pre-wizard.component.html',
  styleUrls: ['./reservation-pre-wizard.component.css'],
  providers: [{ provide: ReservationWizardService, useClass: ReservationPreWizardService }]
})

export class ReservationPreWizardComponent implements OnInit, AfterViewInit {

  constructor(private menuService: MenuService
    , public router: Router
    , private reservationWizardService: ReservationWizardService) {
    this.menuService.setMenuTitle('Recepción', 'previa');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.reservationWizardService.onCancelWizard.subscribe(() => {
      this.router.navigated = false;
      this.router.navigate([this.router.url]);
    });
    }

  stepIndex = 0;
  wizard: Wizard = new Wizard();
  @ViewChild('reservationPracticeComponent', {static: false}) reservationPracticeComponent: ReservationPracticeComponent;
  @ViewChild('reservationPatientComponent', {static: false}) reservationPatientComponent: ReservationPatientComponent;
  @ViewChild('reservationQuestionComponent', {static: false}) reservationQuestionComponent: ReservationQuestionComponent;
  @ViewChild('reservationCalendarComponent', {static: false}) reservationCalendarComponent: ReservationExtraordinaryCalendarComponent;
  @ViewChild('stepper', {static: false}) stepper: MatStepper;
  steps: WizardStep[] = [];

  get isQuestionVisible() {
    return this.reservationWizardService.isQuestionVisible;
  }
  get reservationPatientCompleted() {
    return this.reservationPatientComponent ? this.reservationPatientComponent.completed : false;
  }
  get reservationPracticeCompleted() {
    return this.reservationPracticeComponent ? this.reservationPracticeComponent.completed : false;
  }
  get reservationQuestionCompleted() {
    return this.reservationQuestionComponent ? this.reservationQuestionComponent.completed : false;
  }
  get reservationCalendarCompleted() {
    return this.reservationCalendarComponent ? this.reservationCalendarComponent.completed : false;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.steps = this.getSteps();
      this.wizard.configure(this.steps, this.stepper);
      this.wizard.initialize();
      // guardo aca porque cuando se toca el wizard desde los botonos de arriba no hace el submit
      this.stepper.selectionChange.subscribe(($event?: StepperSelectionEvent) => {

        const isNext = this.stepIndex < $event.selectedIndex;
        if (isNext) {
          this.steps[this.stepIndex].save();
        }
        this.stepIndex = $event.selectedIndex;
        let index = -1;
        let complete = true;
        this.steps = this.getSteps();

        while (complete && index < this.stepIndex - 1) {
          index = index + 1;
          complete = this.steps[index].completed;
        }

        if (!complete) {
          this.stepIndex = index;
        } else {
          if (this.steps[this.stepIndex].isInit) {
            this.steps[this.stepIndex].activate();
          }
        }
      });
    }, 0);
  }

  private getSteps() {
    const steps: WizardStep[] = [];
    // se tienen que agregar los pasos en el mismo orden que aparecen
    if (this.reservationPatientComponent) {
      steps.push(this.reservationPatientComponent);
    }
    if (this.reservationPracticeComponent) {
      steps.push(this.reservationPracticeComponent);
    }
    if (this.reservationQuestionComponent) {
      steps.push(this.reservationQuestionComponent);
    }
    if (this.reservationCalendarComponent) {
      steps.push(this.reservationCalendarComponent);
    }
    return steps;
  }
}
